module.exports = __webpack_public_path__ + "static/media/art59.976aef68.jpg";